import styled from "styled-components";

export const Col = styled.div`
    padding: 0 var(--spacing-2);
`;

export const Row = styled.div<{ isClickable?: boolean }>`
    flex: 1 1 auto;
    flex-wrap: wrap;
    margin: 0 calc(var(--spacing-2) * -1);
    padding: var(--spacing-1) 0;
    font-size: 12px;
    line-height: 1.6;
    background: var(--colors-primary-white);
    cursor: ${(props) => (props.isClickable ? "pointer" : "default")};
    overflow-wrap: break-word;

    &:nth-child(even) {
        background: var(--color-grey-1);
    }

    strong {
        margin-inline-end: var(--spacing-1);
        font-size: 13px;
    }

    select {
        border-radius: 3px;
        border-width: 1px;
    }

    span + select {
        margin-inline-start: 6px;
    }

    input[type="checkbox"] {
        margin-inline-end: 6px;
        vertical-align: middle;
    }
`;
